module.exports = __webpack_public_path__ + "img/age.fca91d69.png";